import { useMutation } from '@apollo/client/react';
import { Form as AntdForm, Button, Card, Input, Typography, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { LOGIN_ADMIN } from '../gqls/admin';

export const PageLogin = () => {
  const navigate = useNavigate();

  const [messageApi, contextHolder] = message.useMessage();

  const [loginAdmin, { loading }] = useMutation(LOGIN_ADMIN, {
    onError: (err) => {
      console.error(err);
      messageApi.error('Неправильный email или пароль');
    },
    onCompleted: (data) => {
      const accessToken = data?.loginAdmin;
      if (accessToken) {
        localStorage.setItem('accessToken', accessToken);
        navigate('/');
      }
    },
  });

  const handleSubmit = (values) => {
    loginAdmin({ variables: { data: { email: values.email, password: values.password } } });
  };

  return (
    <Content>
      {contextHolder}
      <Card>
        <Form name="login-form" layout="vertical" onFinish={handleSubmit}>
          <Typography.Text style={{ marginBottom: 16, fontSize: 16 }}>Вход в панель администратора</Typography.Text>
          <Form.Item
            layout="vertical"
            label="Электронная почта"
            name="email"
            rules={[
              { required: true, message: 'Введите электронную почту' },
              { type: 'email', message: 'Неправильная электронная почта' },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            layout="vertical"
            label="Пароль"
            name="password"
            rules={[{ required: true, message: 'Введите пароль' }]}
          >
            <Input.Password />
          </Form.Item>
          <Button loading={loading} htmlType="submit" form="login-form" type="primary">
            Войти
          </Button>
        </Form>
      </Card>
    </Content>
  );
};

const Content = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: whitesmoke;
`;

const Form = styled(AntdForm)`
  min-width: 300px;
  display: flex;
  flex-direction: column;
`;
